export default "__VITE_ASSET__Bxnl46Qh__"